// HM-332 placeholder generico per le sezioni in arrivo.

interface Props {
  title: string;
  hint: string;
}

export function Placeholder({ title, hint }: Props) {
  return (
    <div
      className="bg-bg-card border border-border-base rounded-xl p-12 text-center"
      data-testid={`section-${title.toLowerCase()}`}
    >
      <h2 className="text-lg font-semibold text-text-primary mb-1">{title}</h2>
      <p className="text-sm text-text-secondary">{hint}</p>
      <p className="text-xs text-text-muted mt-3 italic">In arrivo (iterazione successiva)</p>
    </div>
  );
}
